import {get, post} from '../../utils/ApiUtil';
import User from '../../models/User';

/**
 * トークンで仮登録ユーザーを取得
 *
 * @param token
 * @returns {Promise<User>}
 */
export async function getUserByRegistrationToken(token) {
  const res = await get('/api/user/auth/get_user_by_registration_token/', {token});
  return new User(res);
}

/**
 * Validate Signup Data (without creating user)
 *
 * @param name
 * @param email
 * @param officeName
 * @param postalCode
 * @param address
 * @param phoneNumber
 * @param organization
 * @returns {Promise<Object>}
 */
export async function validateSignupUser(name, email, officeName, postalCode, address, phoneNumber, organization) {
  return await post('/api/user/auth/validate_signup', {
    name,
    email,
    office_name: officeName,
    postal_code: postalCode,
    address,
    phone_number: phoneNumber,
    organization
  });
}

/**
 * User Registration
 *
 * @param name
 * @param email
 * @param officeName
 * @param postalCode
 * @param address
 * @param phoneNumber
 * @param organization
 * @returns {Promise<User>}
 */
export async function signupUser(name, email, officeName, postalCode, address, phoneNumber, organization) {
  const res = await post('/api/user/auth/signup', {
    name,
    email,
    office_name: officeName,
    postal_code: postalCode,
    address,
    phone_number: phoneNumber,
    organization
  });
  return new User(res);
}

/**
 * User Activation
 *
 * @param token
 * @param password
 * @returns {Promise<User>}
 */
export async function activateUser(token, password) {
  const res = await post('/api/user/auth/activate', {token, password});
  return new User(res);
}

/**
 * ログイン
 *
 * @param email
 * @param password
 * @param remember
 * @returns {Promise<User>}
 */
export async function loginUser(email, password, remember) {
  const data = await post('/api/user/auth/login', {email, password, remember});
  return new User(data);
}

/**
 * ログアウト
 *
 * @returns {Promise<void>}
 */
export async function logoutUser() {
  await post('/api/user/auth/logout');
}

/**
 * ログイン中のユーザーを取得
 *
 * @returns {Promise<User>}
 */
export async function getCurrentUser() {
  const data = await get('/api/user/me');
  return new User(data);
}

/**
 * パスワードのリセットリクエストを送信
 *
 * @param email
 * @returns {Promise<void>}
 */
export async function forgotPassword(email) {
  await post('/api/user/auth/forgot_password', {email});
}

/**
 * パスワードを更新
 *
 * @param email
 * @returns {Promise<void>}
 */
export async function resetPassword(email) {
  await post('/api/user/auth/reset_password', email);
}

/**
 * Change password
 *
 * @param currentPassword
 * @param password
 * @param passwordConfirmation
 * @returns {Promise<Object>}
 */
export async function changePassword(currentPassword, password, passwordConfirmation) {
  return await post('/api/user/auth/change_password', {
    current_password: currentPassword,
    password: password,
    password_confirmation: passwordConfirmation
  });
}

/**
 * Request email address change
 *
 * @param currentEmail
 * @param newEmail
 * @returns {Promise<Object>}
 */
export async function requestEmailChange(currentEmail, newEmail) {
  return await post('/api/user/auth/request_email_change', {
    current_email: currentEmail,
    new_email: newEmail
  });
}

/**
 * Confirm email address change
 *
 * @param token
 * @returns {Promise<Object>}
 */
export async function confirmEmailChange(token) {
  return await post('/api/user/auth/confirm_email_change', {
    token: token
  });
}
